export default "__VITE_ASSET__7qIoqpP$__"